<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="email">Email Name</label>
          <input
            name="email"
            type="text"
            v-model="email"
            placeholder="Enter email"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row submit-row ">
      <div class="col d-flex">
        <div
          class="switch"
          @click="handleSwitchClick"
          :class="{ active: isActive === true }"
        >
          <div class="indicator"></div>
        </div>
        <span @click="handleSwitchClick">{{
          isActive ? "Enabled" : "Disabled"
        }}</span>
      </div>
      <div class="col">
        <ActionButton
          type="submit"
          :theme="{ primary, secondary, event, danger }"
          label="Save"
          style="width: auto; margin-left: auto; margin-top: 0;"
        />
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";

export default {
  name: "AddManager",
  components: {
    ActionButton
  },
  data: () => ({
    email: null,
    isActive: false
  }),
  methods: {
    handleSwitchClick() {
      this.isActive = !this.isActive;
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped></style>
